import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { DocumentZipFilters } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface Props {
  matterId: string;
  subsetId: string;
}

interface CreateZipResponse {
  zipExists: boolean;
  jobId?: string;
  inProgress?: boolean;
  filterHash?: string;
}

export const useCreateDocumentZip = ({ matterId, subsetId }: Props) => {
  const { getFetchConfig } = useGetFetchConfig();

  const createDocumentZip = async (filters?: DocumentZipFilters): Promise<CreateZipResponse> => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        matterId,
        subsetId,
        ...filters,
      },
    });

    const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/docs/create-zip/${subsetId}`, fetchConfig);
    if (!response.ok) {
      throw new Error('Failed to create document zip');
    }

    return await response.json();
  };

  const { mutate: createZip, isLoading: isCreatingZip, error } = useMutation(createDocumentZip);

  return { createZip, isCreatingZip, error };
};
